import { IBtrStaticPageApiModel } from '@app/core/models/api/btr-static-page.api.model';

export class BtrStaticPageModel {
  public title: string;
  public slug: string;
  public shortTitle: string;
  public body: string;
  public imageUrl?: string;
  blocks?: {
    id: number;
    type: 'image';
    link: string;
  };
  dateModified: string;

  constructor(source?: IBtrStaticPageApiModel) {
    this.title = source?.title;
    this.slug = source?.slug;
    this.body = source?.body;
    this.shortTitle = source?.short_title;
    this.blocks = source?.blocks;
    this.imageUrl = source?.image_url
      ?.replace('original', 'thumbnail_1800x600')
      .replace('.png', '.jpg');
    this.dateModified = source?.date_modified;
  }

  static copyObj(
    source: Pick<BtrStaticPageModel, keyof BtrStaticPageModel>,
  ): BtrStaticPageModel {
    return Object.assign(new BtrStaticPageModel(), source);
  }
}
